import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPaymentMethods } from "../../services/apiV2";

export const fetchPaymentMethods = createAsyncThunk(
  "paymentMethods/fetchPaymentMethods",
  async (_, { rejectWithValue, signal }) => {
    try {
      const res = await getPaymentMethods({ config: { signal } });
      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
